export const LOADING_START = 'LOADING_START'
export const LOADING_STOP = 'LOADING_STOP'
export const LOADING_RESET = 'LOADING_RESET'

export const loadingStart = () => ({
  type: LOADING_START
})

export const loadingStop = () => ({
  type: LOADING_STOP
})

export const loadingReset = () => ({
  type: LOADING_RESET
})



// WEBPACK FOOTER //
// ./src/redux/actions/loadingActions.js